import { render } from "./ChangeSharedFSDiskOffering.vue?vue&type=template&id=4f06cf7a&scoped=true"
import script from "./ChangeSharedFSDiskOffering.vue?vue&type=script&lang=js"
export * from "./ChangeSharedFSDiskOffering.vue?vue&type=script&lang=js"

import "./ChangeSharedFSDiskOffering.vue?vue&type=style&index=0&id=4f06cf7a&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f06cf7a"]])

export default __exports__